import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices

import activityReducer from "./slices/activities";
import adminReducer from "./slices/admins";
import authReducer from "./slices/auth";
import bannerReducer from "./slices/banners";
import blogReducer from "./slices/blog";
import bgReducer from "./slices/bloodgroup";
import categoryReducer from "./slices/category";
import championReducer from "./slices/champion";
import countryReducer from "./slices/country";
import fanChoiceReducer from "./slices/fanchoice";
import fanVoiceReducer from "./slices/fanvoice";
import faqReducer from "./slices/faq";
import featureReducer from "./slices/features";
import gameReducer from "./slices/game";
import gameDetailReducer from "./slices/gameDetail";
import keyPersonReducer from "./slices/keyperson";
import lineupReducer from "./slices/lineup";
import photoReducer from "./slices/photo";
import positionReducer from "./slices/positions";
import seasonReducer from "./slices/season";
import sponsorReducer from "./slices/sponsors";
import squadReducer from "./slices/squad";
import stadiumReducer from "./slices/stadium";
import substituteReducer from "./slices/substitute";
import tagReducer from "./slices/tags";
import teamReducer from "./slices/team";
import userReducer from "./slices/user";
import videoReducer from "./slices/video";

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const authPersistConfig = {
  key: "auth",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const blogPersistConfig = {
  key: "blog",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const userPersistConfig = {
  key: "user",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const categoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const faqPersistConfig = {
  key: "faq",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const seasonPersistConfig = {
  key: "season",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const stadiumPersistConfig = {
  key: "season",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const teamPersistConfig = {
  key: "season",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const positionPersistConfig = {
  key: "position",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const keyPersonPersistConfig = {
  key: "keyPerson",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const squadPersistConfig = {
  key: "squad",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const videoPersistConfig = {
  key: "video",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const gamePersistConfig = {
  key: "game",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const countryPersistConfig = {
  key: "country",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const photoPersistConfig = {
  key: "photo",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const sponsorPersistConfig = {
  key: "sponsor",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const adminPersistConfig = {
  key: "admin",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const bgPersistConfig = {
  key: "bg",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const featurePersistConfig = {
  key: "feature",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const bannerPersistConfig = {
  key: "banner",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const tagPersistConfig = {
  key: "tag",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const activityPersistConfig = {
  key: "activity",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const gameDetailPersistConfig = {
  key: "gameDetail",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const lineupPersistConfig = {
  key: "lineup",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const substitutePersistConfig = {
  key: "substitute",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const fanVoicePersistConfig = {
  key: "fanVoice",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const fanChoicePersistConfig = {
  key: "fanChoice",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const championPersistConfig = {
  key: "champion",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  blog: persistReducer(blogPersistConfig, blogReducer),
  feature: persistReducer(featurePersistConfig, featureReducer),
  banner: persistReducer(bannerPersistConfig, bannerReducer),
  user: persistReducer(userPersistConfig, userReducer),
  category: persistReducer(categoryPersistConfig, categoryReducer),
  faq: persistReducer(faqPersistConfig, faqReducer),
  season: persistReducer(seasonPersistConfig, seasonReducer),
  stadium: persistReducer(stadiumPersistConfig, stadiumReducer),
  team: persistReducer(teamPersistConfig, teamReducer),
  position: persistReducer(positionPersistConfig, positionReducer),
  keyPerson: persistReducer(keyPersonPersistConfig, keyPersonReducer),
  squad: persistReducer(squadPersistConfig, squadReducer),
  video: persistReducer(videoPersistConfig, videoReducer),
  game: persistReducer(gamePersistConfig, gameReducer),
  country: persistReducer(countryPersistConfig, countryReducer),
  photo: persistReducer(photoPersistConfig, photoReducer),
  sponsor: persistReducer(sponsorPersistConfig, sponsorReducer),
  admins: persistReducer(adminPersistConfig, adminReducer),
  bloodGroup: persistReducer(bgPersistConfig, bgReducer),
  tag: persistReducer(tagPersistConfig, tagReducer),
  lineup: persistReducer(lineupPersistConfig, lineupReducer),
  activity: persistReducer(activityPersistConfig, activityReducer),
  gameDetail: persistReducer(gameDetailPersistConfig, gameDetailReducer),
  substitute: persistReducer(substitutePersistConfig, substituteReducer),
  fanVoice: persistReducer(fanVoicePersistConfig, fanVoiceReducer),
  fanChoice: persistReducer(fanChoicePersistConfig, fanChoiceReducer),
  champion: persistReducer(championPersistConfig, championReducer),
});

export default rootReducer;
